import { Text } from "@simplybusiness/mobius";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

export const LoadingState = () => (
  <SkeletonTheme
    baseColor="var(--color-background-light)"
    highlightColor="var(--color-background)"
  >
    <div>
      <Text variant="h4">
        Select the business that most closely describes what you do
      </Text>
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="mobius-ai-trade-question__trade-item mobius-ai-trade-question__trade-item--is-loading"
        >
          <Skeleton
            borderRadius="var(--radius-1)"
            containerClassName="mobius-skeleton"
          />
        </div>
      ))}
    </div>
  </SkeletonTheme>
);
